module.exports = __webpack_public_path__ + "img/Asset-2011-100.5251f631.jpg";